var exports = {
  "u": "x43aef4ae--c33359--section",
};

module.exports = exports;
